/* eslint-disable max-len */
export const getPaymentMethod = (state) => (payload) => state.all.find((entry) => entry.id === payload);
